import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import PageContainer from '../../components/containers/PageContainer';
import { useItemDetails } from '../items/hooks/useItemDetails';
import AuctionDetails from './components/AuctionDetails';
import TechnicalUserDetails from './components/TechnicalUserDetails';
import { useTechnicalUser } from './hooks/useTechnicalUser';
import BidsList from './components/BidsList';
import OrderDetails from './components/OrderDetails';

const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  padding: 10px;
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
  gap: 10px;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
`;

type UrlParams = {
  itemId: string;
};

const OnSiteAuctions = () => {
  const { itemId } = useParams<UrlParams>();
  const { auction, item, refetchAuction, refetchItem } = useItemDetails(Number(itemId!!));

  const refetchAuctionAndItem = () => {
    refetchAuction();
    refetchItem();
  };

  const {
    technicalUser,
    technicalUserStatus,
    resolveAuthToken,
    firstName,
    lastName,
    setFirstName,
    setLastName,
    refetchTechnicalUser,
  } = useTechnicalUser(auction);

  return (
    <PageContainer>
      <MainContainer>
        <LeftContainer>
          <AuctionDetails
            auction={auction}
            item={item}
            refetchAuction={refetchAuction}
            refetchAuctionAndItem={refetchAuctionAndItem}
          />
          <TechnicalUserDetails
            technicalUser={technicalUser}
            technicalUserStatus={technicalUserStatus}
            firstName={firstName}
            lastName={lastName}
            setFirstName={setFirstName}
            setLastName={setLastName}
          />
          <OrderDetails
            auction={auction}
            technicalUser={technicalUser}
            technicalUserStatus={technicalUserStatus}
            refetchTechnicalUser={refetchTechnicalUser}
          />
        </LeftContainer>
        <RightContainer>
          <BidsList
            auction={auction}
            resolveAuthToken={resolveAuthToken}
            refetchAuction={refetchAuction}
            technicalUser={technicalUser}
          />
        </RightContainer>
      </MainContainer>
    </PageContainer>
  );
};

export default OnSiteAuctions;
